<template>
  <div ref="chart" class="echarts"></div>
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: 'Pie',
  props: {
    title: {
      type: String,
      default: '',
    },
    echartsOption: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {

      option: {
        title: {
          // eslint-disable-next-line vue/no-unused-properties
          text: this.title,
          // eslint-disable-next-line vue/no-unused-properties
          top: '16px',
          // eslint-disable-next-line vue/no-unused-properties
          left: '16px',
          // eslint-disable-next-line vue/no-unused-properties
          textStyle: {
            fontSize: 16,
            fontWeight: 'normal',
          },
        },
        tooltip: {
          // eslint-disable-next-line vue/no-unused-properties
          trigger: 'item',
          // eslint-disable-next-line vue/no-unused-properties
          formatter(params) {
            const { name, value, percent } = params
            if (value >= 10000) {
              return `${name}<br />&nbsp&nbsp金额:${value / 10000}万元<br />&nbsp&nbsp比例${percent}%`
            }
            return `${name}<br />&nbsp&nbsp金额:${value}元<br />&nbsp&nbsp比例${percent}%`
          },
        },
        color: ['#6FBAFF', '#6E97FF', '#84A6FF', '#A9C1FF', '#A99BFD', '#DE9BFD', '#FFA487', '#FFDEAC', '#FFF7AC', '#C7FFAC', '#8BD080', '#409F83', '#95979A'],
      },
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.chart = echarts.init(this.$refs.chart)
      this.setOption()
    },
    setOption() {
      this.option = Object.assign({}, this.option, this.echartsOption)
      this.chart.setOption(this.option)
    },
  },
}
</script>

<style lang="scss" scoped>
.echarts{
  width: 100%;
  height: 446px;
}
</style>
